import { render, staticRenderFns } from "./auditDetail.vue?vue&type=template&id=88d0c9b4&scoped=true&"
import script from "./auditDetail.vue?vue&type=script&lang=js&"
export * from "./auditDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d0c9b4",
  null
  
)

export default component.exports